import getIsDesktop from "selectors/device/getIsDesktop";
import getIsFirefox from "selectors/device/getIsFirefox";
import getIsSafari from "selectors/device/getIsSafari";
import getBrowserVersionFloat from "selectors/device/getBrowserVersionFloat";
import getIsChrome from "selectors/device/getIsChrome";
import { createSelector } from "reselect";

const getCanInitiallyAutoplay = createSelector(
  [
    getBrowserVersionFloat,
    getIsChrome,
    getIsDesktop,
    getIsFirefox,
    getIsSafari,
  ],
  (browserVersionFloat, isChrome, isDesktop, isFirefox, isSafari) =>
    isDesktop &&
    !isFirefox &&
    !(isSafari && browserVersionFloat >= 11) &&
    !(isChrome && browserVersionFloat >= 66),
);

export default getCanInitiallyAutoplay;
